//third-party imports
import { Component, Input } from '@angular/core';
/**
 *
 *
 * @export
 * @class BsMultiSelectComponent
 */
@Component({
    selector: 'rs-multi-select',
    templateUrl: './rs-multi-select.component.html',
    styleUrls: ['../../../scss/styles.scss'],
    standalone: false
})
export class RsMultiSelectComponent {
    @Input() element;
}
